import { render, staticRenderFns } from "./VideoContainerSitecore.vue?vue&type=template&id=31ad6360"
import script from "./VideoContainerSitecore.vue?vue&type=script&lang=js"
export * from "./VideoContainerSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports